import { SafeHtml } from '@angular/platform-browser';
import { MngColor } from '@mng/mng-icon';
import { ValidatorFn } from '@angular/forms';

export interface CustomDialogValidator {
  validatorFunction: ValidatorFn;
  errorId: string;
  errorMessage: string;
}

export interface IDialogOptions {
  htmlContent?: string;
  title?: string;
  iconName?: string;
  iconColor?: MngColor;
  type?: DialogType;
  textInput?: string;
  customTextInputValidator?: CustomDialogValidator;
  width?: string;
  autoselect?: boolean;
  cancelButton?: boolean;
  okText?: string;
  cancelText?: string;
  yesText?: string;
  noText?: string;
  minDate?: Date;
  maxDate?: Date;
}

export type DialogCallbackFunction = (value: string) => void;

export interface IDialogOutcomeFunctionDef {
  [actionOutcome: string]: DialogCallbackFunction;
}

export enum DialogType {
  YesNo,
  Ok,
  TextInput,
  TextInputAsDate
}

export interface BaseDialogData {
  title: string;
  iconName?: string;
  iconColor?: MngColor;
  bodyHtml?: SafeHtml;
  dialogType: DialogType;
  autoselect: boolean;
  cancelEnabled: boolean;
  okText?: string;
  yesText?: string;
  cancelText?: string;
  noText?: string;
  minDate?: Date;
  maxDate?: Date;
  customValidator?: CustomDialogValidator;
}

export const DIALOG_RESULT_ANY = 'any';
export const DIALOG_RESULT_YES = 'yes';
export const DIALOG_RESULT_NO = 'no';
export const DIALOG_RESULT_OK = 'ok';
export const DIALOG_RESULT_CANCEL = 'cancel';
